<template>
  <div id="forgot_password">
    <form @submit.prevent="sendCode" class="step_a" v-if="step == 1">
        <ul>
            <li>
                <input type="email" v-model="email" placeholder="הכנס אמייל">
            </li>
            <input type="submit" value="שלח קוד">
        </ul>
    </form>
    <form @submit.prevent="validateCode" class="step_b" v-if="step == 2">
        <ul>
            <li>
                <input type="text" v-model="code">
            </li>
            <input type="submit" value="שלח קוד">
        </ul>
    </form>
    <form @submit.prevent="" class="step_c" v-if="step == 3">
        <ul>
            <li >
                  <label>בחירת סיסמא</label>
                  <div class="eye" >
                    <div v-if="!showPassword" @click="showPassword=!showPassword">
                        <i class="fas fa-eye"></i>
                    </div>
                    <div v-else @click="showPassword=!showPassword">
                        <i class="fas fa-eye-slash"></i>
                    </div>
                    <input :type="showPassword ? 'text' : 'password'" name="password" required v-model="password">
                  </div>
                  <span class="helper_text">לפחות 8 תווים</span>
              </li>
              <li>
                  <label>סיסמא בשנית</label>
                  <input :type="showPassword ? 'text' : 'password'" name="password"  required v-model="repeatPasswortInput">
                  <!-- <span class="helper_text">לפחות 8 תווים</span> -->
              </li>
            <input type="submit" value="שלח קוד">
        </ul>
    </form>
  </div>
</template>

<script>
export default {
    data() {
        return {
            step: 1,
            email: '',
            code: '',
            password: '',
            repeatPasswortInput: '',
            showPassword: false

        }
    },
    methods: {
        sendCode() {
            this.api({ 'action': 'forgot_password', data: { email: this.email}}, (data) => {
				if (data.data === true) this.step = 2
				else this.alert('משתמש לא נמצא');
			});
        },
        validateCode() {
            this.api({ 'action': 'forgot_password2', data: { code: this.code}}, (data) => {
				if (data.data === true) this.show_page = 3
				else this.alert('קוד לא תקין');
			});
        }
    }
}
</script>

<style>

</style>